<template>
    <div class='UnlockedIcon'>
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-unlock-fill" fill="#000" xmlns="http://www.w3.org/2000/svg">
            <path d="M.5 9a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V9z"/>
            <path fill-rule="evenodd" d="M8.5 4a3.5 3.5 0 1 1 7 0v3h-1V4a2.5 2.5 0 0 0-5 0v3h-1V4z"/>
        </svg>
    </div>
</template>
<script>
export default{
    name: 'UnlockedIcon'
}

</script>